/* Cozy Warmth - product page
   Variant picker, media gallery, sticky buy bar. */

(function () {
  'use strict';

  document.querySelectorAll('[data-product-root]').forEach(initProduct);

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-product-root]').forEach(initProduct);
  });

  function initProduct(root) {
    if (root.dataset.initialised === 'true') return;
    root.dataset.initialised = 'true';

    var dataScript = root.querySelector('[data-product-json]');
    if (!dataScript) return;

    var product;
    try {
      product = JSON.parse(dataScript.textContent);
    } catch (error) {
      return;
    }

    var form = root.querySelector('[data-product-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var priceBox = root.querySelector('[data-variant-price]');
    var submit = root.querySelector('[data-add-button]');
    var inventory = root.querySelector('[data-variant-inventory]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    /* ------------------------------------------------------------ gallery */

    var mainImage = root.querySelector('[data-gallery-main] img');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');

    function showMedia(index) {
      var thumb = root.querySelector('[data-gallery-thumb="' + index + '"]');
      if (!thumb || !mainImage) return;
      var img = thumb.querySelector('img');
      if (!img) return;
      mainImage.src = img.dataset.full || img.src;
      mainImage.srcset = img.dataset.fullSrcset || '';
      mainImage.alt = img.alt;
      thumbs.forEach(function (node) {
        node.setAttribute('aria-current', node === thumb ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(thumb.dataset.galleryThumb);
      });
    });

    /* ------------------------------------------------------ variant picker */

    function selectedOptions() {
      return Array.prototype.map.call(
        root.querySelectorAll('[data-option-index]'),
        function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        }
      );
    }

    function findVariant(options) {
      return product.variants.find(function (variant) {
        return options.every(function (value, index) {
          return value === null || variant.options[index] === value;
        });
      });
    }

    function markUnavailable(options) {
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var groupIndex = parseInt(group.dataset.optionIndex, 10);
        group.querySelectorAll('input').forEach(function (input) {
          var probe = options.slice();
          probe[groupIndex] = input.value;
          var match = product.variants.find(function (variant) {
            return probe.every(function (value, index) {
              return value === null || variant.options[index] === value;
            });
          });
          input.disabled = !match || !match.available;
        });
      });
    }

    function renderPrice(variant) {
      if (!priceBox) return;
      var html = '<span>' + window.formatMoney(variant.price) + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var save = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        html +=
          '<s class="price__compare">' + window.formatMoney(variant.compare_at_price) + '</s>' +
          '<span class="price__save">Save ' + save + '%</span>';
      }
      priceBox.innerHTML = html;
      // When volume tiers are on, the sticky bar shows the selected tier total instead.
      if (stickyPrice && !root.querySelector('[data-tiers]')) {
        stickyPrice.textContent = window.formatMoney(variant.price);
      }
    }

    function update() {
      var options = selectedOptions();
      var variant = findVariant(options);

      markUnavailable(options);

      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var label = group.querySelector('[data-option-value]');
        var checked = group.querySelector('input:checked');
        if (label && checked) label.textContent = checked.value;
      });

      if (!variant) {
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      renderPrice(variant);

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? submit.dataset.labelAvailable : 'Sold out';
      }

      if (inventory) {
        if (variant.available && variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 10) {
          inventory.textContent = 'Only ' + variant.inventory_quantity + ' left in stock';
          inventory.hidden = false;
        } else {
          inventory.hidden = true;
        }
      }

      if (variant.featured_media_index !== null && variant.featured_media_index !== undefined) {
        showMedia(variant.featured_media_index);
      }

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('[data-option-index] input').forEach(function (input) {
      input.addEventListener('change', update);
    });

    update();

    /* ------------------------------------------------------- volume tiers */

    var tierWrap = root.querySelector('[data-tiers]');
    if (tierWrap) {
      var tierQuantity = root.querySelector('[data-tier-quantity]');

      var applyTier = function (input) {
        tierWrap.querySelectorAll('.tier').forEach(function (card) {
          card.classList.toggle('tier--active', card.contains(input));
        });

        if (tierQuantity) tierQuantity.value = input.dataset.quantity;
        if (stickyPrice) stickyPrice.textContent = input.dataset.price;

        // The form carries the code so the shared add-to-cart handler can apply it.
        if (form) {
          if (input.dataset.discount) {
            form.dataset.discountCode = input.dataset.discount;
          } else {
            delete form.dataset.discountCode;
          }
        }
      };

      tierWrap.addEventListener('change', function (event) {
        var input = event.target.closest('input[name="volume-tier"]');
        if (input) applyTier(input);
      });

      var checkedTier = tierWrap.querySelector('input[name="volume-tier"]:checked');
      if (!checkedTier) checkedTier = tierWrap.querySelector('input[name="volume-tier"]');
      if (checkedTier) {
        checkedTier.checked = true;
        applyTier(checkedTier);
      }
    }

    /* ----------------------------------------------------- sticky buy bar  */

    var sticky = document.querySelector('[data-sticky-buy]');
    if (sticky && submit) {
      sticky.querySelector('[data-sticky-add]').addEventListener('click', function () {
        if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });

      if ('IntersectionObserver' in window) {
        var watcher = new IntersectionObserver(function (entries) {
          sticky.dataset.visible = entries[0].isIntersecting ? 'false' : 'true';
        }, { rootMargin: '-120px 0px 0px 0px' });
        watcher.observe(submit);
      }
    }
  }
})();
